(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.querySelector('.header__mobile-toggle');
    const nav = document.querySelector('.header__nav');
    const header = document.querySelector('.site-header');

    if (toggle && nav) {
      toggle.addEventListener('click', function() {
        nav.classList.toggle('active');
      });
    }

    // Scroll effect for header
    function handleScroll() {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state

    // Mobile dropdown toggle
    const dropdownItems = document.querySelectorAll('.has-dropdown');

    dropdownItems.forEach(function(item) {
      const link = item.querySelector('.menu-link');

      link.addEventListener('click', function(e) {
        // Only prevent default on mobile (when menu is in mobile layout)
        if (window.innerWidth <= 968) {
          const hasSubmenu = item.querySelector('.dropdown-menu');
          if (hasSubmenu) {
            e.preventDefault();
            item.classList.toggle('active');

            // Close other open dropdowns
            dropdownItems.forEach(function(otherItem) {
              if (otherItem !== item) {
                otherItem.classList.remove('active');
              }
            });
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["investment-types"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const investmentItems = document.querySelectorAll('.investment-item');
    const investmentImages = document.querySelectorAll('.investment-image');

    // Set first item as active
    if (investmentItems.length > 0) {
      investmentItems[0].classList.add('active');
    }

    investmentItems.forEach((item) => {
      item.addEventListener('mouseenter', function() {
        const investmentId = this.getAttribute('data-investment-id');

        // Remove active class from all items
        investmentItems.forEach(i => i.classList.remove('active'));

        // Add active class to hovered item
        this.classList.add('active');

        // Hide all images
        investmentImages.forEach(img => {
          img.style.display = 'none';
        });

        // Show corresponding image
        const targetImage = document.querySelector(`[data-image-id="${investmentId}"]`);
        if (targetImage) {
          targetImage.style.display = 'block';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const track = document.querySelector('.testimonials__track');
    if (!track) return;

    const cards = track.querySelectorAll('.testimonial-card');
    const prevButton = document.querySelector('.nav-button--prev');
    const nextButton = document.querySelector('.nav-button--next');

    if (cards.length === 0) return;

    let currentIndex = 0;
    let cardsPerView = 3;

    function updateCardsPerView() {
      if (window.innerWidth <= 768) {
        cardsPerView = 1;
      } else if (window.innerWidth <= 1024) {
        cardsPerView = 2;
      } else {
        cardsPerView = 3;
      }
    }

    function updateCarousel() {
      const cardWidth = cards[0].offsetWidth;
      const gap = 32; // 2rem
      const offset = currentIndex * (cardWidth + gap);
      track.style.transform = `translateX(-${offset}px)`;

      // Update button states
      if (prevButton && nextButton) {
        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= cards.length - cardsPerView;
      }
    }

    function nextSlide() {
      if (currentIndex < cards.length - cardsPerView) {
        currentIndex++;
        updateCarousel();
      }
    }

    function prevSlide() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', prevSlide);
    }

    if (nextButton) {
      nextButton.addEventListener('click', nextSlide);
    }

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        const oldCardsPerView = cardsPerView;
        updateCardsPerView();
        if (oldCardsPerView !== cardsPerView) {
          currentIndex = 0;
        }
        updateCarousel();
      }, 150);
    });

    // Initialize
    updateCardsPerView();
    updateCarousel();
  });

  } catch(e) { console.error(e); }
})();
})();
